export default "/images/vendor/flag-icon-css/flags/1x1/me.svg?3b8260d491f0ed64b1ad45d0e624888d";